import { render, staticRenderFns } from "./RoApcnPopupTableInfo9.vue?vue&type=template&id=6728c54f&"
import script from "./RoApcnPopupTableInfo9.vue?vue&type=script&lang=js&"
export * from "./RoApcnPopupTableInfo9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports